import http from "@/utils/request";
import axios from "axios";

export function merchantadd(data: Req.merchantadd) {
  return http.post<Res.response<Res.merchantadd>>({
    url: "/merchant/add",
    data,
  });
}

export function merchantupdate(data: Req.merchantadd) {
  return http.post<Res.response<Res.merchantadd>>({
    url: "/merchant/update",
    data,
  });
}

export function merchantgetOtherConfig() {
  return http.get<Res.response<Res.merchantgetOtherConfig>>({
    url: "/merchant/getOtherConfig",
  });
}

// 商户列表
export function merchantgetMerchantCentorDto(data: Req.merchantgetMerchantCentorDto) {
  return http.post<Res.response<any>>({
    url: "/merchant/getMerchantCentorDto",
    data,
  });
}
// 获取开通门店
export function listMerchantStoreDtos(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/listMerchantStoreDtos",
    data,
  });
}
// 商户详细信息
export function merchantinfo(data: any) {
  return http.get<Res.response<any>>({
    url: "/merchant/info?merchantId=" + `${data.merchantId}`,
    data,
  });
}

// 启用禁用
export function merchantupdatemerchantstatus(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/update/merchant/status",
    data,
  });
}

// 重置密码
export function merchantrestPassword(data: { merchantId: number; command: string }) {
  return http.get<Res.response<any>>({
    url: "/merchant/restPassword?merchantId=" + `${data.merchantId}&command=` + `${data.command}`,
    data,
  });
}

// 开户/续费
export function paymanagementgetall() {
  return http.get<Res.response<any>>({
    url: "/pay/management/get/all",
  });
}

//扩店/开户/续费
export function merchantexpense(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/expense",
    data,
  });
}

//到期提醒
export function merchantexpireremindlist(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/expire/remind/list",
    data,
  });
}

// 计算天数
export function merchantdiffDay(data: { endTime: any; nowTime: any }) {
  return http.get<Res.response<any>>({
    url: "/merchant/diffDay?nowTime=" + `${data.nowTime}&endTime=` + `${data.endTime}`,
    data,
  });
}

//获取参数
export function configget(data: any) {
  return http.post<Res.response<any>>({
    url: "/config/get",
    data,
  });
}

//修改参数
export function configmodify(data: any) {
  return http.post<Res.response<any>>({
    url: "/config/modify",
    data,
  });
}

// 折扣开关
export function paymanagementdiscountswitch(data: { isOpen: any; command: any }) {
  return http.get<Res.response<any>>({
    url: "/pay/management/discount/switch?isOpen=" + `${data.isOpen}&command=` + `${data.command}`,
    data,
  });
}

//修改折扣
export function paymanagementupdateconfig(data: any) {
  return http.post<Res.response<any>>({
    url: "/pay/management/update/config",
    data,
  });
}

//折扣 - 到期提醒  - 变更记录
export function paymanagementgetlogs(data: any) {
  return http.post<Res.response<any>>({
    url: "/pay/management/get/logs",
    data,
  });
}

//付费记录
export function merchantorderlist(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/order/list",
    data,
  });
}
//添加发票
export function addInvoice(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/order/add/invoice",
    data,
  });
}

// 到期提醒备注详情
export function merchantexpireremindremarklist(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/expire/remind/remark/list",
    data,
  });
}

// 添加备注
export function merchantexpireaddremark(data: any) {
  return http.post<Res.response<any>>({
    url: "/merchant/expire/add/remark",
    data,
  });
}

// 分销商户下拉
export function merchantgetAll(data: { isFilter: boolean }) {
  return http.get<Res.response<any>>({
    url: `/merchant/merchant/all?isFilter=${data.isFilter}`,
  });
}
